import * as types from '../actions/types';

const initialState = {
    wait: false,
    data: [],
    selected: null,
    error: null,
};

export default function (state=initialState, {type, payload}) {
    switch (type) {
      // CREATE
      case types.CREATE_CHART_WAIT:
          return {
              ...state,
              wait: true,
          };
      case types.CREATE_CHART_SUCCESS:
          return {
              ...state,
              wait: false,
              selected: payload,
          };
      case types.CREATE_CHART_ERROR:
          return {
              ...state,
              wait: false,
              error: payload,
          };

      // detail
      case types.GET_DETAIL_CHART_WAIT:
          return {
              ...state,
              selected: null
          };
      case types.GET_DETAIL_CHART_ERROR:
          return {
              ...state,
              error: payload,
          };
      case types.GET_DETAIL_CHART_SUCCESS:
          return {
              ...state,
              selected: payload,
          };

      // update
      case types.UPDATE_CHART_SUCCESS:
          return {
              ...state,
              selected: payload,
          };

        default:
            return state;
    }
}
